import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
import { legalDocuments, type LegalDocument } from '../data/legal';
type FooterProps = {
  brand?: string;
  disclaimer?: string;
  variant?: 'navy' | 'coal';
  documents?: LegalDocument[];
};
const DEFAULT_DISCLAIMER = 'Este material es educativo y se basa en los derechos que la ley FCRA otorga a los consumidores en Estados Unidos. No somos una agencia de reparación de crédito ni ofrecemos asesoría legal. Los resultados varían según el historial de cada persona.';
export function Footer({
  brand = 'Crédito Limpio en 30 Días',
  disclaimer = DEFAULT_DISCLAIMER,
  variant = 'navy',
  documents = legalDocuments
}: FooterProps) {
  const [activeDoc, setActiveDoc] = useState<LegalDocument | null>(null);
  const background = variant === 'coal' ? 'bg-coal-deep' : 'bg-navy-deep';
  const linkHover = variant === 'coal' ? 'hover:text-ember focus-visible:ring-ember' : 'hover:text-gold focus-visible:ring-gold';
  return <footer className={`w-full ${background}`} data-id="element-68" data-mp="3l90nfv0aswyq">
      <div className="mx-auto w-full max-w-3xl px-5 pb-24 pt-10 text-center sm:px-6 sm:pb-12 sm:pt-12 md:pb-12" data-id="element-69" data-mp="3l9shv2i5sonf">
        <p className="text-base font-bold text-white sm:text-lg" data-id="element-70" data-mp="3gctqgrpvqvsx">{brand}</p>
        <p className="mx-auto mt-3 max-w-xl text-[0.8rem] leading-relaxed text-white/50 sm:mt-4 sm:text-sm" data-id="element-71" data-mp="3v9azvdeie0cu">
          {disclaimer}
        </p>

        <nav aria-label="Enlaces legales" className="mt-5 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 sm:mt-6" data-id="element-72" data-mp="82qrxrmhzrt7">
          {documents.map((doc, index) => <React.Fragment key={doc.id} data-id="element-73" data-mp="hsk2qqetg2we" data-mpi={index}>
              {index > 0 && <span className="text-white/20" aria-hidden="true" data-id="element-74" data-mp="huo5v64w4xvm">
                  ·
                </span>}
              <button type="button" onClick={() => setActiveDoc(doc)} className={`rounded text-[0.8rem] font-medium text-white/70 underline underline-offset-4 outline-none transition-colors duration-150 ease-smooth focus-visible:ring-2 sm:text-sm ${linkHover}`} data-id="element-75" data-mp="qt8flhsh3x7p">
                {doc.label}
              </button>
            </React.Fragment>)}
        </nav>

        <p className="mt-5 text-[0.7rem] text-white/35 sm:mt-6 sm:text-xs" data-id="element-76" data-mp="13sipgwuf3qds">
          © {new Date().getFullYear()} {brand}. Todos los derechos reservados.
        </p>
      </div>

      <LegalModal document={activeDoc} onClose={() => setActiveDoc(null)} data-id="element-77" data-mp="1cmdvs879zmv0" />
    </footer>;
}